import { render, staticRenderFns } from "./Diff.vue?vue&type=template&id=b6c0fd84&scoped=true"
import script from "./Diff.vue?vue&type=script&lang=js"
export * from "./Diff.vue?vue&type=script&lang=js"
import style0 from "./Diff.vue?vue&type=style&index=0&id=b6c0fd84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c0fd84",
  null
  
)

export default component.exports